module.exports = "./images/Sofortüberweisung_Logo.svg";